export const coreTeam = [
  {
    id: 1,
    name: "HARISH L",
    role: "CO-FOUNDER & CEO",
    bio: "Passionate about entrepreneurship, innovation, and technology, Harish leads MEKARO’s vision, strategy, and business development. He focuses on identifying real-world problems, building impactful solutions, and creating opportunities that bring technology and innovation closer to the next generation.",
    linkedin: "https://www.linkedin.com/in/harish0746",
    email: "harishl7406@gmail.com",
    avatar: "robotics-tutor-1",
    image: "/assets/Coreteam/WhatsApp Image 2026-08-09 at 21.02.34.jpeg"
  },
  {
    id: 2,
    name: "KANNAN SURESH VV",
    role: "CO-FOUNDER & CTO",
    bio: "A Computer Science enthusiast with a strong interest in software development and emerging technologies, Kannan leads MEKARO’s technical direction. He works on transforming ideas into practical, scalable solutions while exploring the intersection of software, automation, robotics, and intelligent systems.",
    linkedin: "https://www.linkedin.com/in/kannan-suresh-vadakke-veetil-65a913303/",
    email: "kannasureahvv1227@gmail.com",
    avatar: "iot-tutor-2",
    image: "/assets/Coreteam/kanna.jpg"
  },
  {
    id: 3,
    name: "HARI HARAN G",
    role: "CO-FOUNDER & COO",
    bio: "Focused on operations, execution, and organizational growth, Hari Haran ensures MEKARO’s ideas move from planning to real-world implementation. He coordinates projects, manages execution, and works closely with the team to build meaningful technology-driven initiatives and learning experiences.",
    linkedin: "https://www.linkedin.com/in/hariharan9141/",
    email: "hhariharan489@gmail.com",
    avatar: "drone-tutor-3",
    image: "/assets/Coreteam/hari.jpg"
  },
  {
    id: 4,
    name: "ASHWIN KUMAR N",
    role: "CO-FOUNDER & ADMIN",
    bio: "Responsible for administration, coordination, and organizational management, Ashwin plays a key role in keeping MEKARO’s operations structured and efficient. He supports project coordination, documentation, team activities, and the smooth execution of MEKARO’s initiatives.",
    linkedin: "https://www.linkedin.com/in/ashwin-kumar-bb6473298/",
    email: "ashwinkumarachu005@gmail.com",
    avatar: "drone-tutor-3",
    image: "/assets/Coreteam/ash.jpg"
  }
];
